import { Component, computed, input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { groupBy, GroupResult, orderBy } from '@progress/kendo-data-query';
import { FormSchemaMiniDto } from '@unity/clients';
import { DropdownClickableControlComponent } from '../dropdown-clickable-control/dropdown-clickable-control.component';

@Component({
  selector: 'unity-dropdown-form-schemas-control',
  imports: [DropdownClickableControlComponent],
  templateUrl: './dropdown-form-schemas-control.component.html',
  styleUrl: './dropdown-form-schemas-control.component.scss',
})
export class DropdownFormSchemasControlComponent {
  public readonly $control = input.required<FormControl>({ alias: 'control' });
  public readonly $selectable = input.required<(GroupResult | FormSchemaMiniDto)[]>({ alias: 'selectable' });
  public readonly $displayName = input.required<string>({ alias: 'displayName' });
  public readonly $description = input.required<string>({ alias: 'description' });

  protected readonly $grouped = computed(() => {
    const selectable = this.$selectable();
    return groupBy(
      orderBy(selectable, [
        {
          field: 'current_state_name',
          dir: 'asc',
        },
        {
          field: 'name',
          dir: 'asc',
        },
      ]),
      [
        {
          field: 'current_state_name',
        },
      ]
    );
  });
}
